import * as Scrivito from "scrivito";
import { sectionColors } from "^/config/attributeConsts";

const FactWidget = Scrivito.provideWidgetClass("FactWidget", {
  attributes: {
    key: "string",
    value: "string",
    description: "string",
    destination: "link",
    icon: "string",
    iconPosition: ["enum", { values: ["top", "right"] }],
    iconSize: [
      "enum",
      { values: ["100", "200", "300", "400", "500", "600", "700"] },
    ],
    iconSizeMobile: [
      "enum",
      { values: ["100", "200", "300", "400", "500", "600", "700"] },
    ],
    iconSizeTablet: [
      "enum",
      { values: ["100", "200", "300", "400", "500", "600", "700"] },
    ],
    backgroundImage: ["reference", { only: "Image" }],
    boxStyle: [
      "enum",
      {
        values: sectionColors,
      },
    ],
  },
  extractTextAttributes: ["key", "value", "description"],
});

export default FactWidget;
